import { useMutation } from '@tanstack/react-query';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useApplyFriendsByCode() {
  return useMutation<RespondedType, ResponseError, string>({
    mutationKey: ['/ApplyFriendByRegisterCode'],
    mutationFn: (params) =>
      fetcher(
        '/ApplyFriendByRegisterCode',
        {
          RegisterCode: params,
          Source: 'QRCode',
        },
        { validResponseCodes: [0] },
      ),
    onSettled: (data, error) => {
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      });
    },
  });
}
